/**
 * App logo component
 */

// React
import React from 'react';

import { styled } from '@mui/material/styles';
import logo from 'assets/images/logo.svg';

const Image = styled('img')({
  width: '100%',
  height: '42px',
});

// Component
const Header: React.FC = () => {
  return <Image src={logo} alt="Omotas logo" />;
};

export default Header;
